var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCopyBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3630_14365)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.167 16.3333C16.7068 16.3333 16.3337 16.7064 16.3337 17.1667V24.6667C16.3337 25.1269 16.7068 25.5 17.167 25.5H24.667C25.1272 25.5 25.5003 25.1269 25.5003 24.6667V17.1667C25.5003 16.7064 25.1272 16.3333 24.667 16.3333H17.167ZM14.667 17.1667C14.667 15.786 15.7863 14.6667 17.167 14.6667H24.667C26.0477 14.6667 27.167 15.786 27.167 17.1667V24.6667C27.167 26.0474 26.0477 27.1667 24.667 27.1667H17.167C15.7863 27.1667 14.667 26.0474 14.667 24.6667V17.1667Z",
    fill: "#918F93"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.333 10.5C11.112 10.5 10.9 10.5878 10.7438 10.7441C10.5875 10.9004 10.4997 11.1123 10.4997 11.3333V18.8333C10.4997 19.0543 10.5875 19.2663 10.7438 19.4226C10.9 19.5789 11.112 19.6667 11.333 19.6667H12.1663C12.6266 19.6667 12.9997 20.0398 12.9997 20.5C12.9997 20.9602 12.6266 21.3333 12.1663 21.3333H11.333C10.67 21.3333 10.0341 21.0699 9.56524 20.6011C9.0964 20.1323 8.83301 19.4964 8.83301 18.8333V11.3333C8.83301 10.6703 9.0964 10.0344 9.56524 9.56557C10.0341 9.09673 10.67 8.83334 11.333 8.83334H18.833C19.496 8.83334 20.1319 9.09673 20.6008 9.56557C21.0696 10.0344 21.333 10.6703 21.333 11.3333V12.1667C21.333 12.6269 20.9599 13 20.4997 13C20.0394 13 19.6663 12.6269 19.6663 12.1667V11.3333C19.6663 11.1123 19.5785 10.9004 19.4223 10.7441C19.266 10.5878 19.054 10.5 18.833 10.5H11.333Z",
    fill: "#918F93"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3630_14365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopyBg);
export default __webpack_public_path__ + "static/media/icon-copy-bg.b9db36d79f750d7cc1ca064c7b097c3c.svg";
export { ForwardRef as ReactComponent };